import React from 'react';
import PropTypes from 'prop-types';

import './style.css';

const ReviewButton = ({ desktop }) => (
  <a
    className={`review-button${desktop ? '-desktop' : ''}`}
    href="/rate-my-box/"
  >
    <i className="fal fa-star" />
    Review My Box
  </a>
);

ReviewButton.propTypes = {
  desktop: PropTypes.bool,
};

ReviewButton.defaultProps = {
  desktop: false,
};

export default ReviewButton;
